// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2a7c6858","95":"8f8a11f4","214":"09900aec","419":"891970e6","439":"d9fbfbdb","765":"74cba3cd","774":"51b82445","787":"42f903a8","858":"cbfd8712"}[chunkId] + ".chunk.js";
};